import React, { FC, lazy, Suspense } from "react";
import { BaseProp } from "entities/BaseProp";
import HelmetComponent from "components/HelmetComponent/HelmetComponent";
import AboutUsBanner from "./components/AboutUsBanner";
import AboutUsInfo from "./components/AboutUsInfo";
import AboutUsGoals from "./components/AboutUsGoals";
import AboutUsBeyondBrilliant from "./components/AboutUsBeyondBrilliant";
import AboutUsTailored from "./components/AboutUsTailored";
import AboutUsEcoConscious from "./components/AboutUsEcoConscious";
import AboutUsGetInTouch from "./components/AboutUsGetInTouch";
import AboutUsBranches from "./components/AboutUsBranches";

// Lazy load components

export interface AboutUsProps extends BaseProp {}

const AboutUs: FC<AboutUsProps> = ({ className = "" }) => {
  return (
    <div className={`nc-AboutUs ${className} text-sm sm:text-base`} data-nc-id="AboutUs">
      {/* Title & meta data */}
      <HelmetComponent
        title="About CSC LED | Leaders in Sustainable LED Lighting Solutions"
        metaDescription="Learn about CSC LED, a trusted provider of innovative and energy-efficient LED lighting products. Discover our mission, values, and commitment to delivering high-quality, sustainable lighting solutions."
        metaKeywords="About CSC LED, LED lighting company, Sustainable lighting solutions, Energy-efficient lighting provider, CSC LED mission and values, High-quality LED products, LED lighting expertise, Lighting innovation"
      />
      <AboutUsBanner />
      <AboutUsInfo />
      <AboutUsGoals />
      <AboutUsBeyondBrilliant />
      <AboutUsTailored />
      <AboutUsEcoConscious />
      <AboutUsGetInTouch />
      <AboutUsBranches />
    </div>
  );
};

export default AboutUs;
